import React, { forwardRef } from 'react';
export const InputIcon = (StyledInputIcon) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledInputIcon ref={ref} {...props}>
        {children}
      </StyledInputIcon>);
});
